(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["desk-mat-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('desk-mat-hero-slider')) {
    customElements.define('desk-mat-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        clearInterval(this.timer);
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.slides = Array.from(this.querySelectorAll('.dh-slide'));
        this.dots = Array.from(this.querySelectorAll('[data-slide]'));
        this.index = Math.max(0, this.slides.findIndex(slide => !slide.hidden));
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.userPaused = false;
        this.editorPaused = false;
        this.hovered = false;
        this.focused = this.contains(document.activeElement);
        this.toggle = this.querySelector('[data-toggle]');
        if (this.slides.length < 2) return;
        this.querySelector('.dh-controls').hidden = false;

        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button) return;
          if (button.hasAttribute('data-prev')) this.show(this.index - 1, true);
          if (button.hasAttribute('data-next')) this.show(this.index + 1, true);
          if (button.hasAttribute('data-slide')) this.show(Number(button.dataset.slide), true);
          if (button.hasAttribute('data-toggle')) {
            this.userPaused = !this.userPaused;
            this.sync();
          }
        }, options);
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true);
        }, options);
        this.addEventListener('mouseenter', () => { this.hovered = true; this.sync(); }, options);
        this.addEventListener('mouseleave', () => { this.hovered = false; this.sync(); }, options);
        this.addEventListener('focusin', () => { this.focused = true; this.sync(); }, options);
        this.addEventListener('focusout', event => {
          if (!this.contains(event.relatedTarget)) { this.focused = false; this.sync(); }
        }, options);
        document.addEventListener('visibilitychange', () => this.sync(), options);
        this.motion.addEventListener('change', () => this.sync(), options);

        // A selected slide must remain visible in Shopify's Theme Editor.
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorPaused = true;
          this.show(index, false);
        }, options);
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorPaused = false;
          this.sync();
        }, options);
        this.show(this.index, false);
      }

      show(index, announce) {
        const count = this.slides.length;
        if (!count) return;
        this.index = (index + count) % count;
        this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
        this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
        if (announce) {
          const dot = this.dots[this.index];
          this.querySelector('[data-status]').textContent = dot.getAttribute('aria-label') + ' / ' + count;
        }
        this.sync();
      }

      sync() {
        clearInterval(this.timer);
        if (this.toggle) {
          this.toggle.hidden = this.motion.matches;
          this.toggle.textContent = this.userPaused ? this.toggle.dataset.play : this.toggle.dataset.pause;
        }
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.motion.matches ||
            this.userPaused || this.editorPaused || this.hovered || this.focused || document.hidden) return;
        this.timer = setInterval(() => this.show(this.index + 1, false), Math.max(3000, Number(this.dataset.interval) || 5000));
      }

      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
